import { connect } from "react-redux";
import { clearMessagesAction } from "redux-store/messages";
import { Messages } from "ui/messages/messages";

function mapStateToProps(state) {
  const { messages } = state.global.messages;

  return {
    messages,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    clearAll: () => {
      dispatch(clearMessagesAction);
    },
  };
}

const ConnectedMessages = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Messages);

export { ConnectedMessages };
